import { useEffect, useState } from "react";

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

const channels = [
  { key: "weibo", label: "微博", icon: "ri-weibo-line", color: "bg-primary-50 text-primary-600" },
  { key: "wechat", label: "微信朋友圈", icon: "ri-wechat-line", color: "bg-accent-100 text-accent-800" },
  { key: "qq", label: "QQ 空间", icon: "ri-qq-line", color: "bg-secondary-100 text-secondary-800" },
  { key: "link", label: "复制链接", icon: "ri-link", color: "bg-background-100 text-foreground-700" },
];

export default function ShareModal({ open, onClose, title }: ShareModalProps) {
  const [activeChannel, setActiveChannel] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setActiveChannel(null);
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center px-4">
      <button
        type="button"
        aria-label="关闭分享窗口"
        onClick={onClose}
        className="absolute inset-0 cursor-pointer bg-foreground-950/50"
      />
      <div className="animate-fade-up relative w-full max-w-md rounded-lg border border-background-200 bg-background-50 p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.2em] text-primary-600">分享内容</p>
            <h2 className="mt-1 font-heading text-lg font-bold text-foreground-950">分享这篇内容</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 hover:text-foreground-900"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <p className="mt-3 line-clamp-2 rounded-md bg-background-100 px-3 py-2 text-xs leading-relaxed text-foreground-600">
          {title}
        </p>

        <div className="mt-5 grid grid-cols-4 gap-2">
          {channels.map((channel) => (
            <button
              key={channel.key}
              type="button"
              onClick={() => setActiveChannel(channel.key)}
              className={[
                "flex cursor-pointer flex-col items-center gap-2 rounded-md border px-1 py-3 text-[11px] transition-colors",
                activeChannel === channel.key
                  ? "border-primary-400 bg-primary-50/60 text-primary-700"
                  : "border-background-200 text-foreground-600 hover:border-primary-200",
              ].join(" ")}
            >
              <span className={`flex h-9 w-9 items-center justify-center rounded-full text-lg ${channel.color}`}>
                <i className={channel.icon} />
              </span>
              <span className="whitespace-nowrap">{channel.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-4 rounded-md border border-dashed border-accent-300 bg-accent-50 px-3 py-2.5 text-xs leading-relaxed text-accent-900">
          <i className="ri-information-line mr-1" />
          演示模式：本站未接入真实分享接口，选择渠道仅展示交互效果，不会真的发布内容。
        </div>
      </div>
    </div>
  );
}